import { Box } from '@mui/material';
import { t } from 'i18next';
import React, { PropsWithChildren } from 'react';

import Button from '../././Button';

const wrapperStyle = {
  display: 'flex',
  flexGrow: 1,
  justifyContent: 'flex-end',
};

interface FormFooterRightProps {
  crammed?: boolean;
  loading?: boolean;
  onCancel?: (e: any) => void;
  onSubmit?: (e: any) => void;
  submitLabel?: string;
}

const FormFooterRight: React.FC<PropsWithChildren<FormFooterRightProps>> = ({
  children,
  crammed,
  loading,
  onCancel,
  onSubmit,
  submitLabel,
}) => {
  if (children) {
    return <Box sx={wrapperStyle}>children</Box>;
  }

  return (
    <Box sx={wrapperStyle}>
      {onCancel && (
        <Button icon={crammed ? 'close' : ''} variant="text" onClick={onCancel}>
          {!crammed && t('form.cancel')}
        </Button>
      )}
      {submitLabel && (
        <Button icon={crammed ? 'check' : ''} loading={loading} type="submit" onClick={onSubmit}>
          {!crammed && submitLabel}
        </Button>
      )}
    </Box>
  );
};

export default FormFooterRight;
